// styles/lib/icons.scss
type Icon =
  'bold' |
  'italic' |
  'mail-1' |
  'bookmark' |
  'zoom-in' |
  'up-open' |
  'down-open' |
  'right-open' |
  'left-open' |
  'close' |
  'cancel-5' |
  'cross-2' |
  'plus' |
  'plus-2' |
  'tick-2' |
  'ok' |
  'search' |
  'search-1' |
  'mail' |
  'pencil' |
  'pencil-1' |
  'home-clear' |
  'home-filled' |
  'communities' |
  'communities-solid' |
  'messages' |
  'messages-solid' |
  'bell-2' |
  'bell-2-solid' |
  'thumbs-up' |
  'thumbs-up-filled' |
  'like-outline' |
  'like-filled' |
  'paper-plane' |
  'cog' |
  'settings' |
  'information' |
  'help' |
  'picture' |
  'newsfeed' |
  'people' |
  'profile-1' |
  'alert' |
  'in-reply' |
  'lock' |
  'link-ext' |
  'logout' |
  'facebook' |
  'twitter' |
  'youtube' |
  'instagram' |
  'bookmark-empty' |
  'underline' |
  'smile' |
  'at';

export default function Icon({icon, className}: {icon: Icon, className?: string}) {
  return (
    <span className={`icon icon-${icon} ${className ? className : ''}`} />
  );
}
